import React from "react";
import { Form, Segment, Grid, Icon } from "semantic-ui-react";
import Button from "../../../elements/Button";
import Result from "../../../../common/repository/Result";
import { toast } from "../../../common/Toast";
import MrdDocuments from "../../../../models/MrdDocuments";
import config from "../../../../common/repository/config";
import DocumentMrdRepository, { UpdateDocumentPendencyRM } from "../../../../common/repository/DocumentMrdRepository";
interface ExpenseDetail {
  _id: string;
  amount: string;
  receipt: string[];
  paymentStatus: string;
  paymentDate: string;
  utrNumber: string;
  amount_status: string;
  receipt_status: string;
  history_id: string;
  amount_rejection_reason?: string | null;
  receipt_rejection_reason?: string | null;
}


interface Props {
  model?: MrdDocuments;
  expenseDetails?: ExpenseDetail[];
  onSuccess: (documentPendency: MrdDocuments) => void;
  onError?: () => void;
}

interface State {
  form_loading: boolean;
  caseId: string,
  investigatorId: string,
  expenseDetails: ExpenseDetail[];
}

class DocumenMrdForm extends React.Component<Props, State> {
  private documentPendencyRepo = new DocumentMrdRepository();

  constructor(props: Props) {
    super(props);
    const stateFromModel = this.deriveMRDFromModel();
    this.state = {
      form_loading: false,
      ...stateFromModel,
    };
  }

  private deriveMRDFromModel = () => {
    const model = this.props.model;
    const rawExpenseDetails = model?.getExpenseDetials() || [];

    // Map to camelCase keys
    const expenseDetails = rawExpenseDetails.map((item) => ({
      ...item,
      paymentDate: item.payment_date,
      paymentStatus: item.payment_status,
      utrNumber: item.utr_number,
      amount_status: item.amount_status,
      receipt_status: item.receipt_status,
    }));

    return {
      caseId: model?.getCaseId() || "",
      investigatorId: model?.getInvestigatorId() || "",
      expenseDetails,
    };
  };


  // private onSubmit = () => {
  //   this.setState({ form_loading: true }, () => {
  //     this.updateDocumentPendency();
  //   });
  // };

  private updateDocumentPendency = async () => {
    const { investigatorId, expenseDetails } = this.state;
    const { model } = this.props;

    if (!model) return;

    const payload: UpdateDocumentPendencyRM = {
      caseId: model.getCaseId(),
      investigatorId,
      expenseDetails: expenseDetails.map((item) => ({
        _id: item._id,
        paymentDate: item.paymentDate,
        utrNumber: item.utrNumber,
        paymentStatus: item.paymentStatus
      })),
    };

    const result = await this.documentPendencyRepo.updateData(payload);

    if (result instanceof Result.Success) {
      const updatedData = result.data?.[0];
      this.setState({ form_loading: false }, () => {
        toast.success("Information updated successfully"); 

        if (updatedData) {
          this.props.onSuccess(updatedData);
        } else {
          toast.warn("Update succeeded but no data returned");
        }
      });

    } else {
      this.setState({ form_loading: false }, () => {
        toast.error(result.message || "Something went wrong");
        this.props.onError?.();
      });
    }
  };






  //   if (result instanceof Result.Success) {
  //     this.setState({ form_loading: false }, () => {
  //       toast.success("Information updated successfully");
  //       this.props.onSuccess(result.data[0]);
  //     });
  //   } else {
  //     this.setState({ form_loading: false }, () => {
  //       toast.error(result.message || "Something went wrong");
  //       this.props.onError?.();
  //     });
  //   }
  // };
  handleExpenseDetailChange = (index: number, field: string, value: any) => {
    const updated: any = [...this.state.expenseDetails];
    updated[index][field] = value;
    this.setState({ expenseDetails: updated });
  };


  render(): JSX.Element {
    return (
      <Form loading={this.state.form_loading} style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <Segment>
          <h4>Expense Details</h4>

          {this.state.expenseDetails.map((item, index) => (

            <Segment key={item._id || index}>
              {/* Row 1 */}
              <Form.Group widths={2}>
                <Form.Input
                  label={`Amount #${index + 1}`}
                  value={item.amount}
                  readOnly
                />
                <Form.Input
                  label={`Amount #${index + 1} Status`}
                  value={item.amount_status}
                  readOnly
                />
              </Form.Group>

              {/* Row 2 */}
              <Form.Group widths={2}>
                <Form.Input
                  label={`Receipt #${index + 1} Status`}
                  value={item.receipt_status}
                  readOnly
                />

                <Form.Input
                  label={`Payment Date #${index + 1}`}
                  type="date"
                  value={item.paymentDate ? item.paymentDate.split("T")[0] : undefined}
                  onChange={(e) => {
                    const updated = [...this.state.expenseDetails];
                    updated[index].paymentDate = e.target.value;
                    this.setState({ expenseDetails: updated });
                  }}
                />

              </Form.Group>

              {/* Row 3 */}
              <Form.Group widths={2}>
                <Form.Input
                  label={`UTR #${index + 1}`}
                  placeholder="Enter UTR Number"
                  value={item.utrNumber}
                  onChange={(e) =>
                    this.handleExpenseDetailChange(index, "utrNumber", e.target.value)
                  }
                />

                {/* <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
        <label>Receipt Image</label>
        <img
          src={config.mrdRecipt + item.receipt[item.receipt.length - 1]}
          alt="Receipt"
          style={{ maxWidth: '100%', maxHeight: '100px', objectFit: 'contain' }}
        />
      </div> */}

                <Form.Field width={8}>
                  <label>{`Payment #${index + 1} Status: `}<span style={{ color: item.paymentStatus === "Approved" ? "green" : "red", fontWeight: "bold" }}>{item.paymentStatus}</span></label>
                  {item.paymentStatus === "Approved" ? (
                    <Form.Input value="Approved" readOnly />
                  ) : (
                    <Form.Select
                      placeholder="Select Status"
                      value={item.paymentStatus}
                      options={[
                        // { key: "pending", value: "Pending", text: "Pending" },
                        { key: "approved", value: "Approved", text: "Approved" },

                      ]}
                      onChange={(e, { value }) => {
                        this.handleExpenseDetailChange(index, "paymentStatus", value);
                      }}
                    />
                  )}
                </Form.Field>

              </Form.Group>
            </Segment>
          ))}

        </Segment>


        <Button positive onClick={this.updateDocumentPendency}>
          Submit
        </Button>

      </Form>
    );
  }
}
export default DocumenMrdForm;
